<template>
  <span>
    {{ totalPercentage }}
  </span>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },

  computed: {
    totalPercentage() {
      const done = this.sections.reduce(
        (acc, section) => (acc += section.done),
        0
      )
      const total = this.sections.reduce(
        (acc, section) => (acc += section.total),
        0
      )

      if (total <= 0) {
        return 'n/a'
      } else {
        return Math.floor((done / total) * 100) + '%'
      }
    },
  },
}
</script>
